import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OhayoLocaleModule } from '@ohayojp.com/theme';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { ReuseTcomponentsontextMenuComponent } from './reuse-tab-context-menu.component';
import { ReuseTcomponentsontextComponent } from './reuse-tab-context.component';
import { ReuseTcomponentsontextDirective } from './reuse-tab-context.directive';
import { ReuseTcomponentsomponent } from './reuse-tab.component';

const COMPONENTS = [ReuseTcomponentsomponent];
const NOEXPORTS = [ReuseTcomponentsontextMenuComponent, ReuseTcomponentsontextComponent, ReuseTcomponentsontextDirective];

@NgModule({
  imports: [CommonModule, RouterModule, OhayoLocaleModule, NzMenuModule, NzTabsModule, NzIconModule, OverlayModule],
  declarations: [...COMPONENTS, ...NOEXPORTS],
  exports: COMPONENTS,
})
export class ReuseTabModule { }
